import { render, staticRenderFns } from "./ClinicStatistics.vue?vue&type=template&id=90b783da&"
import script from "./ClinicStatistics.vue?vue&type=script&lang=js&"
export * from "./ClinicStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports